import styled from "styled-components";
import { BaseGridContainer } from "../../utils/styles";
import { config } from "config/config";

const { bannerBtnPlaceholder } = config;

export const Container = styled(BaseGridContainer)`
  margin: 0 auto;
`;

export const CarouselWrapper = styled.section`
  position: relative;
  overflow: hidden;

  &:hover {
    & > i.leftBtn,
    & > i.rightBtn {
      display: block;
    }
  }

  & > ul.carouselList {
    list-style: none;
    display: flex;
    height: 100%;
    position: absolute;
    margin: 0;
    padding: 0;
    transition: all 0.5s ease;

    & > li {
      position: relative;
      flex: 1;
      background-color: #efefef;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  & > ul.dots {
    position: absolute;
    bottom: 15px;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: center;

    & > li {
      width: 8px;
      height: 8px;
      border-radius: 5px;
      background-color: rgba(255, 255, 255, 0.5);
      margin-right: 10px;
      transition: width 0.5s linear;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background-color: #fff;
        width: 20px;
      }
    }
  }

  & > i {
    display: none;
    width: 24px;
    height: 36px;
    position: absolute;
    top: 50%;
    margin-top: -18px;
    background-color: rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    background-position: center;

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    &.leftBtn {
      left: 0;
      background-image: url(${bannerBtnPlaceholder});
    }
    &.rightBtn {
      right: 0;
      background-image: url(${bannerBtnPlaceholder});
      transform: rotateZ(180deg);
    }
  }
`;
